import { useState, useEffect } from "react";
import Translate from "../../utils/Translate";
import { useApi } from "../../utils/Api";
import Grid from "@mui/material/Grid";
import { Checkbox, FormControlLabel, Switch, Typography } from "@mui/material";

export function ELearningRegSettings({ setIsLoading }) {
  const [eLearningRegFields, setELearningRegFields] = useState([]);
  const preferredOrder = [
    "Name",
    "Email",
    "OrgNo",
    "BirthDate",
    "ExternalActorNo",
    "MobilePhone",
    "Address2",
    "ZipCode",
    "City",
  ];

  const api = useApi();

  useEffect(() => {
    async function fetchData() {
      await getELearningRegFields();
    }
    fetchData();
  }, []);

  async function getELearningRegFields() {
    setIsLoading(true);
    let response = null;
    try {
      response = await api.fetch(`${import.meta.env.VITE_MAIN_URL}dataIdSettings/elearning/regfields`, false, "GET");
      if (response.isSuccessful) {
        setELearningRegFields(response.eLearningRegFields);
      }
    } finally {
      setIsLoading(false);
    }
  }

  async function postELearningRegFields(updatedFields) {
    setIsLoading(true);
    let response = null;
    try {
      const fieldsMap = Object.fromEntries(
        updatedFields.filter((field) => field.visible).map((field) => [field.fieldName, field.required]),
      );
      let reqObj = { regFields: fieldsMap };

      response = await api.fetch(`${import.meta.env.VITE_MAIN_URL}dataIdSettings/elearning/regfields`, reqObj, "POST");
      if (response.isSuccessful) {
        setELearningRegFields(response.eLearningRegFields);
      }
    } finally {
      setIsLoading(false);
    }
  }

  async function handleFieldChange(fieldName, property) {
    const nextFields = eLearningRegFields.map((field) => {
      if (field.fieldName === fieldName) {
        const newValue = !field[property];
        if (property === "visible" && newValue === false) {
          return { ...field, visible: false, required: false };
        }

        return { ...field, [property]: newValue };
      }
      return field;
    });

    setELearningRegFields(nextFields);
    await postELearningRegFields(nextFields);
  }

  function getFieldNameTranslation(name) {
    switch (name) {
      case "OrgNo":
        return "PersonalNo";
      default:
        return name;
    }
  }

  function getSortedFields(fields) {
    return [...fields].sort((a, b) => {
      if (a.systemRequired !== b.systemRequired) {
        return a.systemRequired ? -1 : 1;
      }

      const idxA = preferredOrder.indexOf(a.fieldName);
      const idxB = preferredOrder.indexOf(b.fieldName);

      if (idxA === -1 && idxB === -1) return 0;
      if (idxA === -1) return 1;
      if (idxB === -1) return -1;

      return idxA - idxB;
    });
  }

  return (
    <Grid container spacing={2} style={{ width: "100%" }}>
      <Grid item size={{ md: 6, xs: 6 }}>
        <Typography variant="subtitle2" gutterBottom>
          {Translate.get("Show").toUpperCase()}
        </Typography>
      </Grid>

      <Grid item size={{ md: 6, xs: 6 }} style={{ display: "flex", justifyContent: "flex-end" }}>
        <Typography variant="subtitle2" gutterBottom>
          {Translate.get("Compulsory").toUpperCase()}
        </Typography>
      </Grid>

      {getSortedFields(eLearningRegFields).map((field) => (
        <Grid container key={field.fieldName} alignItems="center" style={{ width: "100%" }}>
          <Grid item size={{ md: 6, xs: 6 }}>
            <FormControlLabel
              control={<Switch checked={field.visible} disabled={field.systemRequired} />}
              label={Translate.get(getFieldNameTranslation(field.fieldName))}
              onChange={() => handleFieldChange(field.fieldName, "visible")}
            />
          </Grid>

          <Grid item size={{ md: 6, xs: 6 }} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Checkbox
              checked={field.required}
              disabled={field.systemRequired || !field.visible}
              onChange={() => handleFieldChange(field.fieldName, "required")}
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
